import { schema } from "normalizr";

const phoneSchema = new schema.Entity(
	"phone",
	{},
	{ idAttribute: (value) => value.phone || "errorPhone" }
);

export default phoneSchema;
